/**
  table批量修改行表头动态输入组件

*/
import objectUtil from '../../../static/js/objectUtil'
import template from '../../../static/js/template'
import compileVariableUtil from '../../../static/js/compileVariableUtil'
import dynamicItemUtil from '../../dynamicFrom/libs/dynamicItemUtil'
const getValue = objectUtil.getValueByPath

export default {
  name: 'batchModifyRender',
  props: {
    store: {
      type: Object,
      default: null,
    },
    // 扩展对象属性会出现在，绑定模板变量的 extend 中
    extendData: {
      type: Object,
      default: null,
    },
    //cell 定义，重点判断是否有输入值组件定义
    editformItem: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array, Object, String, Number, Boolean],
      default: null,
    },
  },
  data() {
    this.parentDataKey = getValue(this.store, 'states.parentDataKey', 'parentFormData')
    return {}
  },

  render(h) {
    var item = this.editformItem
    var componentClassName = 'readText'
    if (item.component && item.component.code) componentClassName = item.component.code
    componentClassName = dynamicItemUtil.convertComponentName(componentClassName)
    var _props = item.parameter || {}
    var field = item.property
    var propsCompileData = compileVariableUtil.getCompileVariable(null, this, this.extendData)
    //特殊处理传递
    propsCompileData.parentData =
      getValue(this.extendData, 'formData') || window[this.parentDataKey]
    propsCompileData.extendData = this.extendData
    let propsCompile = null
    try {
      propsCompile = template.render(_props, propsCompileData)
    } catch (e) {
      propsCompile = _props
    }

    //当为input组件时支持设置maxlength
    if (item.length > 0 && ~['input', 'i-input', 'Input'].indexOf(componentClassName)) {
      propsCompile.maxlength = propsCompile.maxlength ?? item.length
    }
    if (item.disabled) {
      propsCompile.disabled = item.disabled
    }

    // 如果设置只读模式，则优先级最高。
    if (this.disabled) {
      propsCompile.disabled = this.disabled
    }

    let optionModel = null

    optionModel = {
      value: this.value,
      callback: (val) => {
        if (propsCompile.disabled) return
        this.$emit('input', val)
        this.$emit('on-change', val, field)
      },
    }

    propsCompile.transfer = false
    //将store向下传递
    propsCompile.store = this.store

    const vNodeParam = {
      model: optionModel,
    }
    if (componentClassName.indexOf('Pg') > -1) {
      vNodeParam.attrs = { ...vNodeParam.attrs, ...propsCompile }
    } else {
      vNodeParam.props = propsCompile
    }
    return h(componentClassName, vNodeParam)
  },
}
